import { combineReducers } from 'redux';

export function createReducer(reducers) {
  return combineReducers(reducers);
}

export default createReducer;
